export interface IVectorizationParameters {
    preset: number;
    model: string;
    image_type: string;
    pix2pix_input_image_resemblance: number;
    pix2pix_input_text_promt_resemblance: number;
    pix2pix_prompt: string;
    santa_side_n: number;
    santa_padding: number;
}

export interface ICreateVectorizationPresetsRequest {
    file_name: string;
    input_file_key: string;
    presets: number[]
}

export interface IImageUploadFieldModel {
    key: string;
    "x-amz-algorithm": string;
    "x-amz-credential": string;
    "x-amz-date": string;
    "x-amz-security-token": string;
    policy: string;
    "x-amz-signature": string;
}

export interface ICreatInputImageUploadResponseModel {
    url: string;
    fields: IImageUploadFieldModel;
    input_file_key: string;
    is_uploaded: boolean;
}

export interface IVectorizationDataModel {
    created_at: Date;
    created_by: string;
    input_file_key: string;
    file_name: string;
    status: string;
    parameters: IVectorizationParameters;
    batch_id: string;
    schema_version: string;
    ecs_service_version: string;
    processing_started_at: string | null;
    processing_finished_at: string | null;
    is_new_item: boolean;
    vectorization_id: string;
    feedback_rating: number | null;
    feedback_text: string | null;
    svg_stroke_count: number | null;
}

export interface IVectorizedBatchImageModel {
    id: string;
    status: string;
    preset: number;
    url: string;
    fileName: string;
    feedbackRating: number | null;
    feedbackText: string | null;
    svgStrokeCount: number | null;
}

export interface IVectorizedImageBatchModel {
    inputKey: string;
    startedAt: string;
    startedBy: string;
    batchId: string;
    url: string;
    inputFilename: string
    batchImages: IVectorizedBatchImageModel[];
}

export interface IVectorizedFeedbackModelRequest {
    id: string;
    feedbackRating: number | null;
    feedbackText: string | null;
}

export enum VectorizedStatus {
    ALL = "all",
    COMPLETED = "completed",
    PENDING = "pending",
    FAILED = "failed",
    PROCESSING = "processing"
}

export enum ModelType {
    PIX2PIX = "pix2pix",
    HAT = "hat"
}

export const modelNames: Record<ModelType, string> = {
    [ModelType.PIX2PIX]: "Pix2Pix Model",
    [ModelType.HAT]: "Hat Model"
};

